import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";
import Topbar from "../Topbar/Topbar";
import DashboardWidgets from "../DashboardWidgets/DashboardWidgets";
import UserTable from "../PendingApprovalTable/PendingApprovalTable";
import { fetchUsers } from "../../api/adminApi";

const AdminDashboard = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [users, setUsers] = useState([]);

  // Fetch users for both widgets and table
  const loadUsers = async () => {
    try {
      const res = await fetchUsers();
      setUsers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loadUsers();
  }, []);

  return (
    <div className="admin-layout" style={{ display: "flex" }}>
      <Sidebar
        collapsed={sidebarCollapsed}
        toggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)}
        active="Dashboard"
      />
      <main style={{ flexGrow: 1, padding: 24, marginTop: 64 }}>
        <Topbar notificationCount={4} />
        <DashboardWidgets users={users} />
        <UserTable users={users} reloadUsers={loadUsers} />
      </main>
    </div>
  );
};

export default AdminDashboard;
